import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { REMOVE_USER_GROUP_MEMBER_RESOURCE, USER_GROUP_MEMBERS_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const RemoveUserGroupMemberService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_USER_GROUP_MEMBER_RESOURCE,
      method: 'delete',
      request: (organisationId, userGroupId, memberId, t) => ({
        url: apiRoutes.userGroupMembers(organisationId, userGroupId, memberId),
        meta: {
          removeFromOtherList: {
            resource: USER_GROUP_MEMBERS_RESOURCE,
            idProp: 'id',
            id: memberId,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeUserGroupMemberFailed'),
            onSuccessMessage: t('removeUserGroupMemberSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default RemoveUserGroupMemberService;
